export const MY_LIBRARY = "Your Library";
export const personalWorkspace = { id: MY_LIBRARY, name: MY_LIBRARY };
